














import Vue, {VueConstructor} from 'vue'
import SelectInput from '../inputs/select.vue'
export default Vue.extend({
  name: 'SelectField',
  components: {SelectInput},
  props: {
    value: {},
    label: String,
    error: Boolean,
    field: String,
    placeholder: String,
    required: Boolean,
    options: {},
    selectList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    onInput (event: any): any {
      this.$emit('input', event)
    },
    onFocus (event: any): any {
      this.$emit('focus', event)
    },
    onBlur (event: any): any {
      this.$emit('blur', event)
    }
  },
  computed: {
    fieldValue: {
      get (): any {
        return this.value
      },
      set (): any {
      }
    } as any
  }
})
